import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import { withRouter, useHistory } from "react-router-dom";
import NumberFormat from "react-number-format";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import CardContext from "../../context/card/CardContext";
import CartContext from "../../context/cart/CartContext";
import Preloader from "./../layout/Preloader";
import "./UnregRechargeValue.css";
import UnregActionMenu from "../layout/UnregActionMenu";
import useForm from "../../hooks/useForm";
import usePageTitle from "../../hooks/usePageTitle";

const UnregRechargeValue = (props) => {
  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);
  const configContext = useContext(ConfigContext);
  const cardContext = useContext(CardContext);
  const cartContext = useContext(CartContext);

  const { getConfigValueByCode, getConfigValueByName } = configContext;
  const { setAlert, clearAlerts } = alertContext;
  const { user, token } = authContext;
  const { loaded, selectedCard } = cardContext;
  const { loading, addItem } = cartContext;

  const history = useHistory();

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Reload Card",
  });

  const rechargeValues = [10, 20, 30, 40, 50, 100, 200];

  const [card, setCard] = useState({
    cardnumber: "",
    contractid: "",
    rechargevalue: "",
  });
  const [labels, setLabels] = useState({
    cardnumber: "",
    contract: "",
    rechargevalue: "",
  });
  useEffect(() => {
    clearAlerts();
    if (!selectedCard) {
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 473);
      setAlert(msg, "warning");
    }
    let cardnumber = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.cardNumber"
    );
    let contract = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.contract"
    );
    let rechargevalue = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.rechargeValue"
    );
    setLabels({ ...labels, cardnumber, contract, rechargevalue });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const cardnumberRef = useRef(null);
  const contractRef = useRef(null);
  const rechargevalueRef = useRef(null);

  const [selectedContract, setSelectedContract] = useState("");
  const [isRechargeable, setIsRechargeable] = useState("");
  let { contractid, rechargevalue } = card;
  const onChange = (e) => {
    let selectedContract = "";
    if (e.target.name === "contractid") {
      rechargevalue = "";
      selectedContract = e.target.selectedOptions[0].text;
    }
    setCard({ ...card, rechargevalue, [e.target.name]: e.target.value });
    setSelectedContract(selectedContract);
  };

  const checkRechargeability = (contract) => {
    const contractMsg = selectedCard.contracts
      .filter((iContract) => {
        console.log(`iContract.id ${iContract.id}=== contract ${contract}`);
        console.log(`iContract.rechargeable ${iContract.rechargeable}`);
        // console.log(
        //   "TYPEOF",
        //   typeof iContract.id,
        //   typeof contract,
        //   "Match",
        //   iContract.id === parseInt(contract),
        //   iContract.id == contract
        // );
        if (
          iContract.rideSponsorContract &&
          !user.sponsor &&
          iContract.rechargeable &&
          iContract.id === parseInt(contract)
        )
          return true;
        else if (
          !iContract.rechargeable &&
          iContract.id === parseInt(contract)
        ) {
          return iContract.rechargeReason;
        } else return false;
      })
      .map((item) => {
        if (item.rideSponsorContract && !user.sponsor && item.rechargeable) {
          const msg = getConfigValueByCode(
            "generalConfig",
            "WARNING_MSG",
            item.warningCode
          ).replace("\\n", "\n");
          return msg;
        } else {
          console.log("CARDDD:", selectedCard?.serialNumber);
          return `The Q Card® with serial # ${selectedCard?.serialNumber} is not reloadable at this time. \n [Reason: ${item.rechargeReason}]`;
        }
      });

    if (contractMsg.length > 0) {
      console.log(`RESULT ${JSON.stringify(contractMsg[0])}`);
      return contractMsg[0];
    } else return "";
  };

  useEffect(() => {
    if (contractid) {
      console.log(`Check RECHARGEABILITY`);
      clearAlerts();
      const isNotRechargeable = checkRechargeability(contractid);
      if (isNotRechargeable && !isNotRechargeable.includes("WARN")) {
        setIsRechargeable(checkRechargeability(contractid));
      } else {
        setIsRechargeable("");
      }
      if (isNotRechargeable) {
        setAlert(isNotRechargeable, "warning");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractid]);

  const onSubmit = async (e) => {
    e.preventDefault();
    clearAlerts();
    const card = {
      contractid,
      rechargevalue: rechargevalue * 100,
    };
    try {
      const res = await addItem(card, token);
      console.log("Response: ", res);
      const msg = getConfigValueByCode(
        "generalConfig",
        "RESPONSE_MSG",
        res?.msgCode
      );

      if (res && res.msgCode) {
        setAlert(msg, res.status === "ERROR" ? "danger" : "info");
      }
      if (res && res.status && res.status === "SUCCESS") {
        history.push("/billing");
      }
    } catch (err) {
      console.log("$ERR:", err.message);
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };

  // const showLogin = () => {
  //   /* To-DO : Call resentLink API */
  //   console.log("Navigate back to Login");
  // };
  const selectRechargeValue = (e, value) => {
    e.preventDefault();
    if (isRechargeable === "") {
      console.log("Select value", value);
      setCard({ ...card, rechargevalue: value });
    }
  };

  const stateRef = useRef();
  stateRef.current = card;
  const getFeildRange = () => {
    let minVal = 0.0;
    let maxVal = 0.0;
    let msgCode = 0;
    if (loaded && selectedCard) {
      console.log(
        "------------------->rechargeRange in getFieldRange",
        selectedCard.contracts
      );
      selectedCard.contracts.forEach((ele) => {
        console.log("id", ele.id, "contractid", stateRef.current.contractid);
        // console.log(
        //   "TYPEOF",
        //   typeof ele.id,
        //   typeof stateRef.current.contractid,
        //   "Match",
        //   ele.id === parseInt(stateRef.current.contractid),
        //   ele.id == stateRef.current.contractid
        // );
        if (ele.id === parseInt(stateRef.current.contractid)) {
          if (!isRechargeable) {
            maxVal = (
              ele.rechargeInfo.parameters[0].maximumAllowed / 100
            ).toFixed(2);
            minVal = (
              ele.rechargeInfo.parameters[0].minimumInputValue / 100
            ).toFixed(2);
            msgCode = 463;
          }
        }
      });
    }
    return [minVal, maxVal, msgCode];
  };

  const checkFieldRange = (value, fieldName) => {
    //get allowed ranges for the given field
    console.log("Custom Field", fieldName);
    console.log("Custom value", value);
    let [minVal, maxVal, msgCode] = getFeildRange();
    console.log("Custom Field Min", minVal, " Max ", maxVal, isRechargeable);
    if (!isRechargeable) {
      let res = !(value >= minVal && value <= maxVal)
        ? getConfigValueByCode("generalConfig", "RESPONSE_MSG", msgCode)
        : "";
      res = res.replace("{0}", minVal);
      res = res.replace("{1}", maxVal);
      console.log("Custom Field res", res);
      //check the value is within the range
      return res;
    }
  };

  const {
    Popup,
    validateField,
    validateAllFields,
    isFormValid,
    setIsFormValid,
    unformattedValues,
    setUnformattedValues,
  } = useForm({
    inputList: {
      cardnumber: cardnumberRef,
      contractid: contractRef,
      rechargevalue: rechargevalueRef,
    },
    screenName: "recharge_card",
    unformattedValuesList: {
      rechargevalue: 0.0,
    },
    customRules: {
      rechargevalue: checkFieldRange,
    },
    excludePrefix: {
      rechargevalue: true,
    },
  });

  useEffect(() => {
    const isValid = validateAllFields();
    setIsFormValid(isValid);
    console.log("Form is valid", isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [card]);

  return (
    <Fragment>
      <Popup aria-label="alert" aria-live="assertive" />
      {loading && <Preloader />}
      <UnregActionMenu />
      <div
        className="pvtUnregRecharge"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <h1 className="publicView__pageTitle">
          RELOAD CARD
          <div className="publicView__pageTitle__note">
            {/* <span className="required">*</span>denotes a required field */}
          </div>
        </h1>
        <div className="pvtUnregRecharge__formBody">
          {selectedCard && (
            <form noValidate>
              <div className="pvtUnregRecharge__formGroup">
                <label htmlFor="cardnumber" className="defaultFillLabel">
                  {labels.cardnumber}
                  <span className="required" aria-label="Input required">
                    (*Required)
                  </span>
                  :{" "}
                </label>
                <input
                  type="text"
                  name="cardnumber"
                  className="form-control defaultFillText"
                  readOnly
                  value={selectedCard.serialNumber}
                  onBlur={validateField}
                  ref={cardnumberRef}
                  aria-required="true"
                />
                <div></div>
              </div>
              <div className="pvtUnregRecharge__formGroup">
                <label htmlFor="contractid">
                  {labels.contract}
                  <span className="required" aria-label="Input required">
                    (*Required)
                  </span>
                  :{" "}
                </label>
                <select
                  name="contractid"
                  className="form-control"
                  onChange={onChange}
                  value={contractid}
                  onBlur={(e) => validateField(e, labels.contract)}
                  ref={contractRef}
                  aria-required="true"
                >
                  <option value="">--SELECT--</option>
                  {selectedCard.contracts.map((contract) => (
                    <option key={contract.id} value={contract.id}>
                      {contract.contractName}
                    </option>
                  ))}
                </select>
                <div></div>
              </div>
              <div className="pvtUnregRecharge__formGroup">
                <label>Preset Reload Values :</label>
                <div className="pvtUnregRecharge__pillList">
                  {/* <div className="pvtUnregRecharge__l-pillFill"></div> */}
                  {/* <div className="pvtUnregRecharge__pillList"> */}
                  {rechargeValues.map((item, index) => (
                    <button
                      className="pvtUnregRecharge__pillList__pill"
                      key={index}
                      onClick={(e) => selectRechargeValue(e, item)}
                      disabled={isRechargeable !== ""}
                    >
                      ${item}
                    </button>
                  ))}
                  {/* </div> */}
                  {/* <div className="pvtUnregRecharge__r-pillFill"></div> */}
                </div>
              </div>
              <div className="pvtUnregRecharge__formGroup">
                <label htmlFor="rechargevalue">
                  {labels.rechargevalue}
                  <span className="required" aria-label="Input required">
                    (*Required)
                  </span>
                  :{" "}
                </label>
                <NumberFormat
                  name="rechargevalue"
                  className="form-control"
                  onValueChange={(values) => {
                    setCard({
                      ...card,
                      rechargevalue: values.value,
                    });
                    setUnformattedValues({
                      ...unformattedValues,
                      rechargevalue: values.floatValue,
                    });
                  }}
                  value={rechargevalue}
                  prefix={"$"}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  onBlur={(e) => validateField(e, labels.rechargevalue)}
                  disabled={isRechargeable}
                  getInputRef={rechargevalueRef}
                  aria-required="true"
                />
                <div></div>
              </div>
              <div className="pvtUnregRecharge__formGroup">
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div className="pvtUnregRecharge__cartSummary">
                <div className="pvtUnregRecharge__cartSummary__cartTitle">
                  Review {selectedCard.serialNumber}
                </div>
                <div className="pvtUnregRecharge__cartSummary__cartContainer">
                  <div className="pvtUnregRecharge__cartSummary__cartContainer__cartItem">
                    <div>
                      {selectedContract === "" ||
                      selectedContract === "--SELECT--"
                        ? "No products added"
                        : selectedContract}
                    </div>
                    <div>${rechargevalue ? rechargevalue : 0}</div>
                  </div>
                  <div className="pvtUnregRecharge__cartSummary__cartContainer__total">
                    <div>SUBTOTAL:</div>
                    <div>${rechargevalue ? rechargevalue : 0}</div>
                  </div>
                </div>
                <div> </div>
              </div>
              <div className="pvtUnregRecharge__formGroup__action">
                <input
                  type="submit"
                  value="CHECKOUT"
                  className="btn pvtUnregRecharge__formGroup__button"
                  onClick={onSubmit}
                  disabled={!isFormValid || isRechargeable}
                  aria-disabled={!isFormValid || isRechargeable}
                  aria-live="assertive"
                />
                <div></div>
                <div></div>
              </div>
            </form>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(UnregRechargeValue);
